export default {
  supTitle: {
    en: 'Introducing',
  },
  title: {
    en: 'Wellness',
  },
  buttonTitle: {
    en: 'Explore Wellness',
  },
  text: {
    en: `
      Discover new solutions to improve<br />
      focus, boost energy and reduce stress<br />
      & anxiety!
    `,
  },
}
